import { render, staticRenderFns } from "./SelectedVesselCard.vue?vue&type=template&id=67089749"
import script from "./SelectedVesselCard.vue?vue&type=script&lang=js"
export * from "./SelectedVesselCard.vue?vue&type=script&lang=js"
import style0 from "./SelectedVesselCard.vue?vue&type=style&index=0&id=67089749&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports